import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';
import { toggleModal } from '../reducers/generalReducer.js';

export const fetchAllHolidays = createAsyncThunk('holidays/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const holidays = await API.holidays.getAll();
        return holidays;
    } catch (e) {
        return rejectWithValue(e.message);
    }
});

export const fetchHolidays = createAsyncThunk(
    'holidays/fetch',
    async ({ page, query }, { getState, rejectWithValue }) => {
        try {
            const perPage = getState().general.settings.perPage;
            const { maxPageNumber, holidays } = await API.holidays.get(page, perPage, query);
            const currentList = getState().holiday.list;

            return {
                maxPageNumber,
                list: page ? [...currentList, ...holidays] : holidays,
            };
        } catch (e) {
            return rejectWithValue(e.message);
        }
    },
);

export const createHoliday = createAsyncThunk('holidays/create', async ({ data }, { dispatch, rejectWithValue }) => {
    try {
        const holiday = await API.holidays.create(data);
        dispatch(toggleModal({ modal: 'holiday', isOpen: false }));
        notification.info({ message: 'Success', description: 'Holiday was created' });
        return holiday;
    } catch (e) {
        notification.error({ message: 'Error', description: e.message });
        return rejectWithValue(e.message);
    }
});

export const updateHoliday = createAsyncThunk(
    'holidays/update',
    async ({ data, id }, { dispatch, rejectWithValue }) => {
        try {
            await API.holidays.update(data, id);
            dispatch(toggleModal({ modal: 'holidayEdit', isOpen: false }));
            notification.info({ message: 'Success', description: 'Holiday was updated' });
            return { data, id };
        } catch (e) {
            notification.error({ message: 'Error', description: e.message });
            return rejectWithValue(e.message);
        }
    },
);

export const deleteHoliday = createAsyncThunk('holidays/delete', async ({ id }, { rejectWithValue }) => {
    try {
        await API.holidays.delete(id);
        notification.info({ message: 'Success', description: 'Holiday was deleted' });
        return id;
    } catch (e) {
        notification.error({ message: 'Error', description: e.message || 'Server error' });
        return rejectWithValue(e.message);
    }
});
